export const makeBalancesDayAmountsEqualForGraph = balancesArr => { 
    let newBalances = [];
    const balancesToChange = [];
    let max = 0;
    //  find out the max length data array so far
    for (let i = 0; i < balancesArr.length; i++) {
      if (balancesArr[i].data.length > max) {
        max = balancesArr[i].data.length;
      } 
    }
    //  push into balancesToChange if the lengths need to be extended else into newBalances
    for (let i = 0; i < balancesArr.length; i++) {
      if (balancesArr[i].data.length < max) {
        balancesToChange.push(balancesArr[i]);
      } else {
        newBalances.push(balancesArr[i]);
      }
    }  
    
    //  loop balancesToChange and if they extend beyond the length that was previously the max we will need to extend the ones in newBalances as well, also set balancesToChange[i].data as the outer loop iterates
    let needToExtendNewBalances = false;
    for (let i = 0; i < balancesToChange.length; i++) {
      if (balancesToChange[i].data.length === 0) {
        continue;
      }
      if (balancesToChange[i].data[0].x > 0) {
        needToExtendNewBalances = true;
        const tempArr = [];
        for (let j = 0; j < balancesToChange[i].data[0].x; j++) {
          tempArr.push({x: j, y: 0, xlabel: newBalances[0].data[j].xlabel, timeOfBalance: newBalances[0].data[j].timeOfBalance})
        }
        const tempArr2 = [...balancesToChange[i].data];
        balancesToChange[i].data = tempArr.concat(tempArr2);
      }
    }
    //  if there were balances that ended with a length greater than than newBalances we need to extend (extend meaning give every day a point on y when there was not one) newBalances sub arrays to have proper length and extend balancesToChange, else we will just extend balancesToChange 
    if (needToExtendNewBalances) {
      let finalTemp = [];
      let setFinalTemp = false;
      for (let i = 0; i < balancesToChange.length; i++) {
        if (balancesToChange[i].data.length > max && balancesToChange[i].data.length > 0) {
          max = balancesToChange[i].data.length;
          finalTemp[0] = balancesToChange[i];
          setFinalTemp = true;
        } 
      }
      
      if (!setFinalTemp) {
        finalTemp[0] = newBalances[0];
      }
      for (let i = 0; i < newBalances.length; i++) {
        if (newBalances[i].data.length < max) {
        for (let j = newBalances[i].data.length; j < max; j++) {
            newBalances[i].data.push({x: j, y: newBalances[i].data[newBalances[i].data.length - 1].y, xlabel: finalTemp[0].data[j].xlabel, timeOfBalance: finalTemp[0].data[j].timeOfBalance})
          }
        }
      }
      for (let i = 0; i < balancesToChange.length; i++) {
        if (balancesToChange[i].data.length < max && balancesToChange[i].data.length > 0) {
        for (let j = balancesToChange[i].data.length; j < max; j++) {
              balancesToChange[i].data.push({x: j, y: balancesToChange[i].data[balancesToChange[i].data.length - 1].y, xlabel: finalTemp[0].data[j].xlabel, timeOfBalance: finalTemp[0].data[j].timeOfBalance})
          }
        }
      }
    } else {
      for (let i = 0; i < balancesToChange.length; i++) {
        if (balancesToChange[i].data.length < 1) {
          continue;
        } else {
        for (let j = balancesToChange[i].data.length; j < newBalances[0].data.length; j++) {
              balancesToChange[i].data.push({x: j, y: balancesToChange[i].data[balancesToChange[i].data.length - 1].y, xlabel: newBalances[0].data[j].xlabel, timeOfBalance: newBalances[0].data[j].timeOfBalance})
          }
      }
    }
    } 
  //  only add ones that have actual data
    for (let i = 0; i < balancesToChange.length; i++) {
      if (balancesToChange[i].data.length > 0) {
        newBalances.push(balancesToChange[i]);
      }
    }
    //  fill the chart to not cut off at random points and make it so every x has a y
    let fillChartAmt;
    if (newBalances.length) {
      if (newBalances[0].data.length > 30000) {
        fillChartAmt = newBalances[0].data.length + (5000 - (newBalances[0].data.length % 5000));
      } else if (newBalances[0].data.length < 30000 && newBalances[0].data.length > 14000) {
        fillChartAmt = newBalances[0].data.length + (2000 - (newBalances[0].data.length % 2000));
      } else if (newBalances[0].data.length < 14000 && newBalances[0].data.length > 7000) {
        fillChartAmt = newBalances[0].data.length + (1000 - (newBalances[0].data.length % 1000));
      }  else if (newBalances[0].data.length < 7000 && newBalances[0].data.length > 3000) {
        fillChartAmt = newBalances[0].data.length + (500 - (newBalances[0].data.length % 500));
      } else if (newBalances[0].data.length < 3000 && newBalances[0].data.length > 1000) {
        fillChartAmt = newBalances[0].data.length + (200 - (newBalances[0].data.length % 200));
      } else if (newBalances[0].data.length < 1000 && newBalances[0].data.length > 750) {
        fillChartAmt = newBalances[0].data.length + (100 - (newBalances[0].data.length % 100));
      }  else if (newBalances[0].data.length < 750 && newBalances[0].data.length > 300) {
        fillChartAmt = newBalances[0].data.length + (50 - (newBalances[0].data.length % 50));   
      } else  if (newBalances[0].data.length < 300 && newBalances[0].data.length > 150) {
        fillChartAmt = newBalances[0].data.length + (20 - (newBalances[0].data.length % 20));
      } else if (newBalances[0].data.length < 150 && newBalances[0].data.length > 100) {
        fillChartAmt = newBalances[0].data.length + (10 - (newBalances[0].data.length % 10));
      } else if (newBalances[0].data.length < 50) {
        fillChartAmt = newBalances[0].data.length + (5 - (newBalances[0].data.length % 5));
      } 
    }
  
    for (let i = 0; i < newBalances.length; i++) {
      const dateStr = newBalances[i].data[newBalances[i].data.length - 1].xlabel;
      const date = new Date(dateStr.replace(/-/g, "/")); // some browser does not accept certain date format such as 11-01-2021
      if (isNaN(date.getTime())) {
        continue;
      }
      let daysToAddToDate = 1; 
      const day = 60 * 60 * 24 * 1000;
      for(let j = (newBalances[i].data.length - 1); j < fillChartAmt + 1; j++) {
        const currentDate = new Date(date.getTime() + (day * daysToAddToDate));
        newBalances[i].data.push({x: j, y: newBalances[i].data[newBalances[i].data.length - 1].y, xlabel: `${currentDate.toISOString().slice(5,10)}-${currentDate.toISOString().slice(0,4)}`, timeOfBalance: currentDate.getTime().toString()})
        daysToAddToDate += 1;
      }
    }
    
    return newBalances;
  }